import { render, staticRenderFns } from "./BaseDate.vue?vue&type=template&id=d5a7714c&"
import script from "./BaseDate.vue?vue&type=script&lang=ts&"
export * from "./BaseDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports